<div id="head_wrap">
<!--    <div id="closeBtn" *ngIf="isOpenClass==0">-->
<!--        <span id="closeIcon"  (click)="close();">×</span>&lt;!&ndash;<span id="title2" class="fontSize16">情景模拟</span>&ndash;&gt;-->
<!--    </div>-->
  <app-case-practice-head [simulationName]="'coach'" [progress]="progress" (closeClick)="close()" ></app-case-practice-head>
    <!--<h1 id="title" class="fontSize24" >情景模拟</h1>-->
</div>

<div id="wrap">
    <app-scene-text [practiceIndex]="practiceIndex" [content]="sceneText" [picture]="picture"></app-scene-text>

    <ng-template #talkContainer></ng-template>

    <div id="bottom"></div>
</div>

<button id="choiceBtn" [ngClass]="{'choiceBtn_disable':choiceBtnDisable,'choiceBtn_enable':!choiceBtnDisable}" (click)="onChoiceBtnClick()">
      {{buttonTitle}}
</button>

<div id="choice">
    <ul>
      <li *ngFor="let option of questionOptions; let i=index" class="choiceItem" [ngStyle]="{'font-size': isHarmonyOS ? '16px' : ''}" (click)="onChoiceClick(option,i)">
        {{option.short_description ? option.short_description : option.description}}
      </li>
    </ul>
</div>


<div id="toast">
    <div id="toast_picture">
    </div>
    <span id="toast_word" [ngStyle]="{'font-size': isHarmonyOS ? '16px' : ''}" >反馈报告生成中{{dynamicPoint}}</span>
</div>

<div id="shade" (click)="onShadeClick()"></div>

<div id="tip1" class="tip" [ngStyle]="{'font-size': isHarmonyOS ? '16px' : ''}" >
    <p>{{exitTipMessage}}</p>

    <button id="quitBtn" class="btnWord" (click)="exit();">退出</button>
    <button id="continueBtn" class="btnWord" (click)="continue();">继续</button>
</div>



// WEBPACK FOOTER //
// ./src/app/case-practice-main/case-practice-main.component.html